export enum TalentManagerApprovalStatus {
  PENDING = "pending",
  APPROVED = "approved",
  SUSPENDED = "suspended",
}

export enum TalentManagerEngagementStatus {
  ACTIVE = "active",
  PAUSED = "paused",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export enum TimeEntryType {
  CHAT_AUTO = "chatAuto",
  MANUAL = "manual",
}

export enum CreditPurchaseStatus {
  PENDING = "pending",
  COMPLETED = "completed",
  REFUNDED = "refunded",
}
